<template>
  <span class="inline-flex items-center rounded-full bg-primary px-1.5 py-0.5 text-[10px] leading-none font-semibold text-primary-foreground uppercase">
    <slot />
  </span>
</template>

<script>
/** Small "New" style pill next to a label or menu item. */
export default {
  name: 'NewBadge',
};
</script>
